export const convertArrayToMap = <T>(array: Array<T>, selector: (obj: T) => string) =>
  array.reduce((map, obj) => {
    map[selector(obj)] = obj;
    return map;
  }, {} as { [key: string]: T });

export const convertArrayToArrayMap = <T>(array: Array<T>, selector: (obj: T) => string) =>
  array.reduce((map, obj) => {
    const key = selector(obj);
    if (!map[key]) {
      map[key] = [obj];
    } else {
      map[key].push(obj);
    }
    return map;
  }, {} as { [key: string]: Array<T> });
